import { createContext } from 'react';

export const NAVIGATION_PANEL_REVEAL_SURFACE_ATTR =
  'data-navigation-reveal-surface';
export const NAVIGATION_PANEL_REVEAL_DOC_ID_ATTR =
  'data-navigation-reveal-doc-id';
export const NAVIGATION_PANEL_REVEAL_REQUEST_ID_ATTR =
  'data-navigation-reveal-request-id';
export const NAVIGATION_PANEL_REVEAL_RENAME_ATTR =
  'data-navigation-reveal-rename';

export type NavigationPanelRevealRenameFinishReason =
  | 'blur'
  | 'cancel'
  | 'submit';

export const NavigationPanelRevealRenameCompletionContext = createContext<
  (requestId: number, reason: NavigationPanelRevealRenameFinishReason) => void
>(() => {});

export function canCompleteNavigationPanelReveal(options: {
  renameSurfaceReady: boolean;
  rootSectionExpanded: boolean;
}) {
  const { renameSurfaceReady, rootSectionExpanded } = options;
  if (!renameSurfaceReady) {
    return false;
  }

  return rootSectionExpanded;
}

export function hasNavigationPanelTreeNodeRenameIntent(
  surface: HTMLElement,
  renameInputTestId: string | undefined
) {
  const docId = surface.getAttribute(NAVIGATION_PANEL_REVEAL_DOC_ID_ATTR);
  return (
    surface.getAttribute(NAVIGATION_PANEL_REVEAL_RENAME_ATTR) === 'true' &&
    docId !== null &&
    renameInputTestId === `rename-modal-input-${docId}`
  );
}

export function getNavigationPanelRevealRequestId(surface: HTMLElement) {
  const value = surface.getAttribute(NAVIGATION_PANEL_REVEAL_REQUEST_ID_ATTR);
  if (value === null) {
    return null;
  }
  const requestId = Number(value);
  return Number.isSafeInteger(requestId) ? requestId : null;
}
